"use strict";

const _lazy = (factory) => {
	let promise;
	return () => {
		if (!promise) promise = factory();
		return promise;
	};
};

const _modules = {
	//catalog pack
	AppBasket: _lazy(() => import(/* webpackChunkName: 'js/catalog' *//* webpackMode: 'lazy-once' */ './app/AppBasket.js')),
	AppCatalogSorter: _lazy(() => import(/* webpackChunkName: 'js/catalog' *//* webpackMode: 'lazy-once' */ './app/AppCatalogSorter.js')),
	AppSmartFilter: _lazy(() => import(/* webpackChunkName: 'js/catalog' *//* webpackMode: 'lazy-once' */ './app/AppSmartFilter.js')),
	AppWishlist: _lazy(() => import(/* webpackChunkName: 'js/catalog' *//* webpackMode: 'lazy-once' */ './app/AppWishlist.js')),

	//header pack
	AppHeaderMenu: _lazy(() => import(/* webpackChunkName: 'js/header' *//* webpackMode: 'lazy-once' */ './app/AppHeaderMenu.js')),
	AppHeaderSearch: _lazy(() => import(/* webpackChunkName: 'js/header' *//* webpackMode: 'lazy-once' */ './app/AppHeaderSearch.js')),
	AppSectionsMenu: _lazy(() => import(/* webpackChunkName: 'js/header' *//* webpackMode: 'lazy-once' */ './app/AppSectionsMenu.js')),
	AppStickyHeader: _lazy(() => import(/* webpackChunkName: 'js/header' *//* webpackMode: 'lazy-once' */ './app/AppStickyHeader.js')),

	//news pack
	AppNews: _lazy(() => import(/* webpackChunkName: 'js/news' *//* webpackMode: 'lazy-once' */ './app/AppNews.js')),
	AppSubscribe: _lazy(() => import(/* webpackChunkName: 'js/news' *//* webpackMode: 'lazy-once' */ './app/AppSubscribe.js')),

	//order pack
	AppOrder: _lazy(() => import(/* webpackChunkName: 'js/order' *//* webpackMode: 'lazy-once' */ './app/AppOrder.js')),
	AppOrderPaymentRetry: _lazy(() => import(/* webpackChunkName: 'js/order' *//* webpackMode: 'lazy-once' */ './app/AppOrderPaymentRetry.js')),

	//other
	AppAddressEdit : _lazy(() => import(/* webpackChunkName: 'js/auth' *//* webpackMode: 'lazy-once' */ './app/AppAddressEdit.js')),
	AppAuthorization: _lazy(() => import(/* webpackChunkName: 'js/auth' *//* webpackMode: 'lazy-once' */ './app/AppAuthorization.js')),
	AppLocations: _lazy(() => import(/* webpackChunkName: 'js/locations' *//* webpackMode: 'lazy-once' */ './app/AppLocations.js')),
	AppCertificateForm: _lazy(() => import(/* webpackChunkName: 'js/certificate' *//* webpackMode: 'lazy-once' */ './app/AppCertificateForm.js')),
	AppForm: _lazy(() => import(/* webpackChunkName: 'js/form' *//* webpackMode: 'lazy-once' */ './app/AppForm.js')),
	AppProfileEdit: _lazy(() => import(/* webpackChunkName: 'js/profile' *//* webpackMode: 'lazy-once' */ './app/AppProfileEdit.js')),
};

const _assets = {
	//Gallery pack: грузится только на страницах с галереей/лайтбоксом/слайдером
	Swiper: _lazy(() => import(/* webpackChunkName: 'js/assets/gallery' *//* webpackMode: 'lazy-once' */ '../../node_modules/swiper/swiper-bundle.mjs')),
	Fancybox: _lazy(() => import(/* webpackChunkName: 'js/assets/gallery' *//* webpackMode: 'lazy-once' */ '../../node_modules/@fancyapps/ui')),
	EmblaCarousel: _lazy(() => import(/* webpackChunkName: 'js/assets/gallery' *//* webpackMode: 'lazy-once' */ '../../node_modules/embla-carousel')),

	//Forms pack: маски/валидация/подсказки/селекты — обычно используются вместе
	Imask: _lazy(() => import(/* webpackChunkName: 'js/assets/forms' *//* webpackMode: 'lazy-once' */ 'node_modules/imask')),
	Autocomplete: _lazy(() => import(/* webpackChunkName: 'js/assets/forms' *//* webpackMode: 'lazy-once' */ '../../node_modules/@tarekraafat/autocomplete.js')),
	//Важно: используем dist/js, т.к. src/js импортирует scss и порождает отдельный css-чанк (forms.min.css)
	NiceSelect: _lazy(() => import(/* webpackChunkName: 'js/assets/forms' *//* webpackMode: 'lazy-once' */ '../../node_modules/nice-select2/dist/js/nice-select2.js')),
	validatejs: _lazy(() => import(/* webpackChunkName: 'js/assets/forms' *//* webpackMode: 'lazy-once' */ '../../node_modules/jquery-validation/dist/jquery.validate.js')),

	//other
	Rellax: _lazy(() => import(/* webpackChunkName: 'js/assets/rellax' *//* webpackMode: 'lazy-once' */ '../../node_modules/rellax')),
	Honeycrisp: _lazy(() => import(/* webpackChunkName: 'js/assets/honeycrisp' *//* webpackMode: 'lazy-once' */ '../../node_modules/honeycrisp/src/honeycrisp.js')),
	bs5: _lazy(() => import(/* webpackChunkName: 'js/assets/bs5' *//* webpackMode: 'lazy-once' */ '../../node_modules/bs5-toast')),
	ionRangeSlider: _lazy(() => import(/* webpackChunkName: 'js/assets/slider' *//* webpackMode: 'lazy-once' */ '../../node_modules/ion-rangeslider/js/ion.rangeSlider.js')),
	Datepicker: _lazy(() => import(/* webpackChunkName: 'js/assets/datepicker' *//* webpackMode: 'lazy-once' */ '../../node_modules/vanillajs-datepicker/js/Datepicker.js')),
	lazysizes: _lazy(() => import(/* webpackChunkName: 'js/assets/lazy' *//* webpackMode: 'lazy-once' */ '../../node_modules/lazysizes')),
	Scrollyeah: _lazy(() => import(/* webpackChunkName: 'js/assets/scrollyeah' *//* webpackMode: 'lazy-once' */ './modules/Scrollyeah.js')),
	CupertinoPane: _lazy(() => import(/* webpackChunkName: 'js/assets/pane' *//* webpackMode: 'lazy-once' */ '../../node_modules/cupertino-pane')),
	Cookies: _lazy(() => import(/* webpackChunkName: 'js/assets/cookies' *//* webpackMode: 'lazy-once' */ '../../node_modules/js-cookie')),
};

exports.Router = class Router {
  static get modules() {
    return _modules;
  }

  static get assets() {
    return _assets;
  }
}
